module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"cancel":"Abbrechen","newReceipt":"Neuer Beleg"},"en":{"cancel":"Cancel","newReceipt":"New receipt"}}')
  delete Component.options._Ctor
}
